import { Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { CardTableComponent } from "src/app/components/cards/card-table/card-table.component";
import { Condition } from "src/app/models/custom-types";
import { MantenimientosDTO } from "src/app/models/dto/mantenimientos.dto";
import { PrestartDTO } from "src/app/models/dto/prestart.dto";
import { FilterEvent } from "src/app/models/filter";
import { ListColumn } from "src/app/models/list-columns.model";
import { AlertasSwalService } from "src/app/services/alerts.service";
import { Filter } from "src/app/shared/classes/filter";
import Swal, { SweetAlertOptions } from "sweetalert2";
import { ProgramarService } from "../programar/programar.service";
import { MantenimientoForm } from "./form/form.component";
import { MantenimientoDetalleModal } from "./modal-detail/modal.component";
import { MantenimientoIniciarModal } from "./modal-iniciar/modal.component";
import { MantenimientoMaterialModal } from "./modal-material/modal.component";
import { MantenimientoResumenModal } from "./modal-resumen/modal.component";
import { MantenimientoTerminarModal } from "./modal-terminar/modal.component";

import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import * as dayjs from "dayjs";

dayjs.extend(utc);
dayjs.extend(timezone);

@Component({
  selector: "app-mantenimiento",
  templateUrl: "./mantenimiento.component.html",
  styles: [],
})
export class MantenimientoComponent implements OnInit {
  public columns: ListColumn[] = [
    {
      name: "Folio",
      property: "Folio",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Unidad",
      property: "Unidad",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Tipo",
      property: "TipoDesc",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Razon",
      property: "Razon",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Programado",
      property: "FechaProgramadoStr",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Inicio",
      property: "FechaIniciadoStr",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Termino",
      property: "FechaTerminadoStr",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "actions",
      property: "actions",
      visible: true,
      isModelProperty: false,
    },
  ];

  public actions: any[] = [
    {
      desc: "Iniciar",
      action: "start",
      visible: (row) => row.FechaIniciado == null,
    },
    {
      desc: "Reprogramar",
      action: "reprogramar",
      visible: (row) => row.FechaIniciado == null,
    },
    {
      desc: "Cancelar",
      action: "cancel",
      visible: (row) => row.FechaIniciado == null,
    },
    {
      desc: "Ver recepcion",
      action: "recepcion",
      visible: (row) => row.FechaIniciado != null,
    },
    {
      desc: "Ver resumen",
      action: "resumen",
      visible: (row) => row.FechaIniciado != null,
    },
    {
      desc: "Agregar detalle a mantenimiento",
      action: "detail",
      visible: (row) => row.FechaIniciado != null,
    },
    {
      desc: "Uso de material",
      action: "usematerial",
      visible: (row) => row.FechaIniciado != null,
    },
    {
      desc: "Terminar",
      action: "terminar",
      visible: (row) => row.FechaIniciado != null,
    },
  ];

  @ViewChild(CardTableComponent, { static: true })
  public tableComp: CardTableComponent;

  @ViewChild(MantenimientoForm, { static: true })
  public formulario: MantenimientoForm;
  realdata: MantenimientosDTO[];
  askCancelConfig: SweetAlertOptions = {
    title: "Seguro que quieres cancelar el mantenimiento?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Si",
    cancelButtonText: "No",
  };

  constructor(
    public service: ProgramarService,
    private dialog: MatDialog,
    private alerts: AlertasSwalService,
  ) {}

  ngOnInit(): void {
    this.loadRecords();
    this.filter = new Filter<MantenimientosDTO>(
      this.conditions,
      this.columns,
      true,
    );
  }
  loadRecords() {
    this.service.getPending().subscribe(
      (resultData) => {
        const data = resultData.map((m) => {
          const dateIniciado = dayjs.utc(m.FechaIniciado);
          const dateTerminado = dayjs.utc(m.FechaTerminado);

          // Convert to GMT -8 (Pacific Time)
          const gmt8DateIniciado = dateIniciado.tz("America/Los_Angeles");
          const fechaTransform = m.FechaIniciado ? gmt8DateIniciado : null;
          const gmt8DateTerminado = dateTerminado.tz("America/Los_Angeles");
          const fechaTerminadoTransform = m.FechaTerminado
            ? gmt8DateTerminado
            : null;

          return {
            ...m,
            TipoDesc: m.Tipo == 1 ? "Correctivo" : "Preventivo",
            FechaProgramadoStr: dayjs(m.FechaProgramado).format("DD/MM/YYYY"),
            FechaIniciadoStr: fechaTransform
              ? fechaTransform.format("DD/MM/YYYY hh:mm a")
              : "",

            FechaTerminadoStr: fechaTerminadoTransform
              ? fechaTerminadoTransform.format("DD/MM/YYYY hh:mm a")
              : "",
          };
        });
        this.realdata = data;
        this.filter.setDataTable(this.realdata, this.tableComp);
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      },
    );
  }
  //#region Filter

  public filter: Filter<MantenimientosDTO>;
  public conditions: Condition<MantenimientosDTO> = {
    TipoDesc: (o, f) => o.TipoDesc.toLocaleLowerCase().indexOf(f) > -1,
    Folio: (o, f) =>
      (o.Folio ?? "").toString().toLocaleLowerCase().indexOf(f) > -1,
    Unidad: (o, f) =>
      (o.Unidad ?? "").toString().toLocaleLowerCase().indexOf(f) > -1,
    Razon: (o, f) =>
      (o.Razon ?? "").toString().toLocaleLowerCase().indexOf(f) > -1,
  };

  filterdata(e: FilterEvent) {
    this.filter.filterdata(e, this.realdata, this.tableComp);
  }

  //#endregion Filter
  async actionstable(e: { action: string; row: MantenimientosDTO }) {
    if (e.action == "start") {
      this.openDialogIniciar(e.row);
    } else if (e.action == "recepcion") {
      this.formulario.setUpdate(e.row);
    } else if (e.action == "detail") {
      this.openDialogDetail(e.row);
    } else if (e.action == "usematerial") {
      this.openDialogMaterial(e.row);
    } else if (e.action == "terminar") {
      this.openDialogTerminar(e.row);
    } else if (e.action == "resumen") {
      this.openDialogResumen(e.row);
    } else if (e.action == "cancel") {
      this.alerts.ask(this.askCancelConfig).then((result) => {
        if (result.isConfirmed) {
          this.cancelar(e.row);
        }
      });
    } else if (e.action == "reprogramar") {
      const { value: date } = await Swal.fire({
        title: "Reprogramar",
        input: "date",
        didOpen: () => {
          const today = new Date().toISOString();
          Swal.getInput().min = today.split("T")[0];
        },
      });
      if (date) {
        this.reprogramar(e.row, date);
      }
    }
  }
  async openDialogIniciar(row: MantenimientosDTO) {
    this.service.prestart(row.IdUnidad).subscribe(
      async (next: { status: string; data: PrestartDTO }) => {
        const result = await this.dialog
          .open(MantenimientoIniciarModal, {
            data: { ...next.data, FolioMant: row.Folio },
            panelClass: ["w-full", "lg:w-1/2"],
          })
          .afterClosed()
          .toPromise();

        if (result && result.option) {
          if (result.option == "f") {
            this.formulario.setCreate(row);
          } else if (result.option == "r") {
            this.inicarConRecepcion(row.IdMantenimiento, next.data.IdRecepcion);
          }
        }
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      },
    );
  }
  inicarConRecepcion(IdMantenimiento: string, IdRecepcion: string) {
    this.service.inicarConRecepcion(IdMantenimiento, IdRecepcion).subscribe(
      () => {
        this.alerts.correcta("Creado", "Accion realizada correctamente");
        this.loadRecords();
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      },
    );
  }

  async openDialogMaterial(row) {
    const result = await this.dialog
      .open(MantenimientoMaterialModal, {
        panelClass: ["w-full", "lg:w-1/2"],
      })
      .afterClosed()
      .toPromise();

    if (result) {
      this.service
        .addRefaccion({ ...result, IdMantenimiento: row.IdMantenimiento })
        .subscribe(
          async () => {
            const countGood = await this.retryUploadPhotos(
              row.IdMantenimiento,
              result.files,
              "ref",
            );
            const mensajeEvidencias = `Se guardaron ${countGood} evidencias de ${result.files.length} enviadas.`;

            this.alerts.correcta(
              "Correcto",
              "Reparacion guardada." + mensajeEvidencias,
            );
            this.loadRecords();
          },
          (err) => {
            this.alerts.error("error", err.error.Message);
          },
        );
    }
  }

  async openDialogResumen(row) {
    this.service.getResume(row.IdMantenimiento).subscribe(
      async (resultData) => {
        await this.dialog
          .open(MantenimientoResumenModal, {
            panelClass: ["w-full", "lg:w-1/2"],
            data: resultData,
          })
          .afterClosed()
          .toPromise();
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      },
    );
  }

  async openDialogTerminar(row: MantenimientosDTO) {
    this.service.prefinish(row.IdMantenimiento).subscribe(
      async (next: { status: string; data: PrestartDTO }) => {
        const result = await this.dialog
          .open(MantenimientoTerminarModal, {
            data: { ...next.data, FolioMant: row.Folio },
            panelClass: ["w-full", "lg:w-1/2"],
          })
          .afterClosed()
          .toPromise();

        if (result && result.option) {
          if (result.option == "t") {
            this.terminar({ ...next.data, Reasignar: false });
          } else if (result.option == "r") {
            this.terminar({ ...next.data, Reasignar: true });
          }
        }
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      },
    );
  }

  async openDialogDetail(row) {
    const result = await this.dialog
      .open(MantenimientoDetalleModal, {
        panelClass: ["w-full", "lg:w-1/2"],
      })
      .afterClosed()
      .toPromise();

    if (result) {
      this.service
        .addDetalle({
          Descripcion: result.Descripcion,
          IdMantenimiento: row.IdMantenimiento,
        })
        .subscribe(
          async () => {
            const countGood = await this.retryUploadPhotos(
              row.IdMantenimiento,
              result.files,
              "det",
            );
            const mensajeEvidencias = `Se guardaron ${countGood} evidencias de ${result.files.length} enviadas.`;

            this.alerts.correcta(
              "Correcto",
              "Detalle guardado." + mensajeEvidencias,
            );

            this.loadRecords();
          },
          (err) => {
            this.alerts.error("error", err.error.Message);
          },
        );
    }
  }

  terminar(row: any) {
    this.service.terminar(row).subscribe(
      (next) => {
        this.alerts.correcta("Activado", "Accion realizada correctamente");
        this.loadRecords();
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      },
    );
  }

  cancelar(row: any) {
    this.service.cancelar(row.IdMantenimiento).subscribe(
      (next) => {
        this.alerts.correcta("Activado", "Accion realizada correctamente");
        this.loadRecords();
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      },
    );
  }

  reprogramar(row: any, FechaProgramado: Date) {
    this.service
      .reprogramar({ IdMantenimiento: row.IdMantenimiento, FechaProgramado })
      .subscribe(
        (next) => {
          this.alerts.correcta("Creado", "Accion realizada correctamente");
          this.loadRecords();
        },
        (err) => {
          this.alerts.error("error", err.error.Message);
        },
      );
  }
  private async retryUploadPhotos(
    asm: string,
    files: any[],
    service: "det" | "ref",
  ): Promise<number> {
    let countGood = 0;
    let filesToTry = files.slice();

    // eslint-disable-next-line no-constant-condition
    while (true) {
      const newFailed: any[] = [];
      for (const file of filesToTry) {
        try {
          if (service === "ref") {
            await this.service.addPhotoRef(asm, file).toPromise();
          } else if (service === "det") {
            await this.service.addPhotoDet(asm, file).toPromise();
          } else {
            throw new Error("Servicio no reconocido");
          }
          countGood++;
        } catch (error: any) {
          if (error.error.Message === "Fallo a guardar evidencia") {
            newFailed.push(file);
          }
        }
      }

      if (newFailed.length === 0) break;

      const imagesHtml = `
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-top:12px;">
          ${newFailed
            .map(
              (file) => `
            <div style="aspect-ratio:1;overflow:hidden;border-radius:6px;border:1px solid #e2e8f0;">
              <img src="${URL.createObjectURL(file)}"
                style="width:100%;height:100%;object-fit:cover;display:block;" />
            </div>
          `,
            )
            .join("")}
        </div>`;

      const result = await Swal.fire({
        title: "Evidencias fallidas",
        html: `Las siguientes evidencias fallaron al subir:<br>${imagesHtml}`,
        showCancelButton: true,
        confirmButtonText: "Reintentar",
        cancelButtonText: "Continuar",
      });

      if (!result.isConfirmed) break;
      filesToTry = newFailed;
    }

    return countGood;
  }
}
